import InstanceFormDialog from './InstanceFormDialog';

export default InstanceFormDialog;